import React from "react"
import { platforms } from "./constants"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

const PlatformLegend = () => {
  const legendContent = (
    <Tooltip id="platform-legend-tooltip" className="platform-legend-tooltip">
      <div className="flex flex-col gap-4 p-2">
        <div className="text-md font-semibold">Platform Legend</div>
        <div className="text-sm font-semibold">PlatformId: PlatformName</div>
        {platforms.map((item) => (
          <div key={item.id} className="flex items-center gap-2">
            <span>
              {item.PlatformId}: {item.PlatformName}
            </span>
          </div>
        ))}
        <div>
          <a
            href="https://dev.azure.com/WSAudiology/SW/_search?action=contents&text=IcType.hsml&type=code&lp=code-Project&filters=ProjectFilters%7BSW%7DRepositoryFilters%7BFS_FitHIDBContract%7D&pageSize=25&result=DefaultCollection/SW/FS_FitHIDBContract/GBmain//HsmlData/IcType.hsml"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            Based on IcType.hsml
          </a>
        </div>
      </div>
    </Tooltip>
  )

  return (
    <OverlayTrigger
      placement="left"
      overlay={legendContent}
      trigger={["click"]}
      rootClose
    >
      <span
        className="platform-legend-trigger"
        style={{
          cursor: "pointer",
          padding: "5px",
          display: "inline-block",
          background: "lightgray",
        }}
      >
        Platform Legend
      </span>
    </OverlayTrigger>
  )
}

export { PlatformLegend }
